// Mock data for JCAN Resources LLC homepage

export const heroData = {
  title: "Bridging Borders, Building Partnerships",
  subtitle: "We bridge U.S. expertise and capital with emerging-market opportunity—helping businesses navigate complexity, reduce risk, and execute successfully across borders.",
  cta: {
    primary: "Get Started",
    secondary: "Learn More"
  }
};

export const missionData = {
  title: "Our Mission",
  description: "Our mission is to help American and emerging-market businesses succeed across borders by delivering trusted, results-driven advisory services that reduce risk, accelerate growth, and create sustainable economic value."
};

export const visionData = {
  title: "Our Vision",
  description: "To be a premier cross-border advisory firm recognized for enabling successful partnerships, investments, and market expansion between the United States and the developing world."
};

export const strategicGoals = [
  {
    id: 1,
    title: "Trusted Advisory Leadership",
    description: "Establish the firm as a highly trusted advisor for U.S. and developing-market companies navigating complex international business environments.",
    focus: "Long-term relationships, repeat engagements, and referrals",
    icon: "Shield"
  },
  {
    id: 2,
    title: "Outcome-Focused Advisory Services",
    description: "Deliver advisory services that lead to tangible business outcomes, including market entry, joint ventures, capital formation, and operational execution.",
    focus: "Results over reports",
    icon: "Target"
  },
  {
    id: 3,
    title: "Deep Local Market Access",
    description: "Develop and maintain strong networks with local partners, regulators, financial institutions, and industry leaders in target developing markets.",
    focus: "Faster execution, reduced friction, improved deal certainty",
    icon: "Network"
  },
  {
    id: 4,
    title: "Governance, Compliance & Integrity",
    description: "Operate with the highest standards of legal compliance, ethical conduct, and transparency, aligned with U.S. regulations and local market requirements.",
    focus: "Risk mitigation and reputational protection",
    icon: "FileCheck"
  },
  {
    id: 5,
    title: "Sustainable Value Creation",
    description: "Support projects that generate long-term economic value, institutional capacity, and durable growth for clients and local partners.",
    focus: "Sustainable success, not one-time transactions",
    icon: "TrendingUp"
  }
];

export const servicePillars = [
  {
    id: 1,
    title: "Market Entry & Expansion Advisory",
    icon: "Globe",
    services: [
      "Market feasibility and entry strategy",
      "Partner identification and vetting",
      "Regulatory navigation and licensing support"
    ]
  },
  {
    id: 2,
    title: "Strategic Partnerships & Joint Ventures",
    icon: "Handshake",
    services: [
      "Joint venture structuring and negotiations",
      "Public-private partnership advisory",
      "Strategic alliance development"
    ]
  },
  {
    id: 3,
    title: "Capital & Investment Advisory",
    icon: "DollarSign",
    services: [
      "Capital sourcing and investor introductions",
      "Project structuring and financial modeling",
      "Transaction support and due diligence coordination"
    ]
  },
  {
    id: 4,
    title: "Government & Institutional Engagement",
    icon: "Building2",
    services: [
      "Stakeholder mapping and engagement strategy",
      "Government liaison and facilitation support",
      "Development finance and institutional coordination"
    ]
  },
  {
    id: 5,
    title: "Risk, Compliance & Execution Support",
    icon: "AlertCircle",
    services: [
      "Regulatory and compliance alignment",
      "Cross-border operational risk assessment",
      "Project execution oversight and coordination"
    ]
  }
];

export const coreValues = [
  {
    id: 1,
    title: "Integrity",
    description: "We operate transparently, ethically, and in full compliance with applicable laws and regulations.",
    icon: "Scale"
  },
  {
    id: 2,
    title: "Accountability",
    description: "We take ownership of outcomes and deliver on commitments.",
    icon: "CheckCircle"
  },
  {
    id: 3,
    title: "Partnership",
    description: "We succeed by aligning closely with our clients and local stakeholders.",
    icon: "Users"
  },
  {
    id: 4,
    title: "Cultural Intelligence",
    description: "We respect and understand local business practices while upholding global standards.",
    icon: "Globe2"
  },
  {
    id: 5,
    title: "Results Orientation",
    description: "Our work is measured by real-world impact, not theory.",
    icon: "Award"
  }
];

export const statsData = [
  {
    id: 1,
    value: "15+",
    label: "Years Combined Experience"
  },
  {
    id: 2,
    value: "25+",
    label: "Markets Served"
  },
  {
    id: 3,
    value: "100%",
    label: "Client Satisfaction"
  },
  {
    id: 4,
    value: "$500M+",
    label: "Capital Facilitated"
  }
];
